<template>
    <div class="box-widget fl-wrap">
        <div class="box-widget-title fl-wrap">Featured Listings</div>
        <div class="box-widget-content fl-wrap">
            <!--widget-posts-->
            <div class="widget-posts  fl-wrap">
                <ul class="no-list-style">
                    <li v-for="property in featured_properties?.data">
                        <div class="widget-posts-img">
                            <router-link :to="'/listings/'+property?.id">
                                <img :src="property?.images?.[0]?.image_url" alt="" style="width: 100px;">
                            </router-link>
                        </div>
                        <div class="widget-posts-descr">
                            <h4>
                                <router-link :to="'/listings/'+property?.id"
                                             v-html="property?.description "></router-link>
                            </h4>
                            <div class="geodir-category-location fl-wrap">
                                <router-link :to="'/listings/'+property?.id">
                                    <i class="fas fa-map-marker-alt"></i>
                                    {{ property?.local_area }}, {{ property?.location?.name }}
                                </router-link>
                            </div>
                            <div class="widget-posts-descr-price">
                                <span>Category: </span> {{ property?.category?.name }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- widget-posts end-->
            <router-link to="/listings" class="btn float-btn color-bg small-btn">View All Properties</router-link>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "FeaturedProperties",
    data() {
        return {
            filters: {
                featured: "true"
            }
        }
    },
    methods: {
        ...mapActions({
            'getFeaturedProperties': 'listings/getListings'
        })
    },
    computed: {
        ...mapGetters({
            'featured_properties': 'listings/listings'
        })
    },
    created() {
        this.getFeaturedProperties(this.filters)
    }
}
</script>
